<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { cloneDeep } from 'lodash';
import { STATUS_OPEN, STATUS_CLOSED } from '@/constants';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import ToggleSwitch from 'primevue/toggleswitch';

interface Props {
  type: string;
  hotel: object;
}
const props = defineProps<Props>();

const emits = defineEmits<{ validateSwitch: [{ value: any; type: string; switchType: string }] }>();

const hotelTargets = ref(cloneDeep(props.hotel));
const instaQuote = ref();
const status = ref();
const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;

const validateSwitch = (newVal: any, type: string, switchType: string) => {
  if (type === 'PACKAGE_ONLY') {
    if (switchType === 'insta') {
      hotelTargets.value.insta = newVal;
    } else {
      hotelTargets.value.status = newVal;
    }
  } else if (type === 'HOTEL_ONLY') {
    if (switchType === 'insta') {
      hotelTargets.value.instaHotel = newVal;
    } else {
      hotelTargets.value.statusHotel = newVal;
    }
  }
  emits('validateSwitch', {
    value: hotelTargets.value,
    type: type,
    switchType: switchType
  });
};

onMounted(() => {
  if (props.type === 'PACKAGE_ONLY') {
    instaQuote.value = hotelTargets.value.insta;
    status.value = hotelTargets.value.status;
  } else if (props.type === 'HOTEL_ONLY') {
    instaQuote.value = hotelTargets.value.instaHotel;
    status.value = hotelTargets.value.statusHotel;
  }
});
</script>
<template>
  <div class="flex grid">
    <div class="col-4">
      <div class="flex gap-3 align-items-center">
        <div>{{ $t('management.hotel.instance_quote') }} <span class="text-primary">*</span></div>
        <ToggleSwitch v-model="instaQuote" :trueValue="STATUS_OPEN" :falseValue="STATUS_CLOSED" @update:modelValue="validateSwitch($event, type, 'insta')" />
      </div>
    </div>
    <div class="col-4">
      <div class="flex gap-3 align-items-center">
        <div>{{ $t('management.hotel.status') }} <span class="text-primary">*</span></div>
        <ToggleSwitch id="status_package" :disabled="!authorizations?.hotel_configuration?.status_hotel" v-model="status" :trueValue="STATUS_OPEN" :falseValue="STATUS_CLOSED" @update:modelValue="validateSwitch($event, type, 'status')" />
      </div>
    </div>
  </div>
</template>
